import { Chip, CircularProgress } from '@mui/material';
import { OrderTransaction } from './billingData';
import { formatMoney } from '../../services/strings/formatters';

export interface TransactionsTableProps {
    transactions: OrderTransaction[];
    loadingTransaction: boolean
} 

export function TransactionsTable({ transactions, loadingTransaction }: TransactionsTableProps) {
  return (
    <div style={{ position: 'relative' }}>
      {/* Overlay + loader */}
      {loadingTransaction && (
        <div
          style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(255,255,255,0.7)', // light grey overlay
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
          }}
        >
          <CircularProgress />
        </div>
      )}

      {/* Your existing table */}
      <div style={{ overflowX: 'auto', filter: loadingTransaction ? 'grayscale(100%) opacity(0.6)' : 'none' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ backgroundColor: '#eeeeee' }}>
            <tr>
              {['Date', 'Order ID', 'Customer', 'Items', 'Gross', 'Fee', 'Net', 'Type'].map(h => (
                <th
                  key={h}
                  style={{
                    padding: '12px',
                    fontSize: 12,
                    textTransform: 'uppercase',
                    color: '#616161',
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {transactions.map(tx => (
              <tr
                key={tx.id}
                style={{ transition: 'background-color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
              >
                <td style={{ padding: '12px', fontSize: 14 }}>{tx.date}</td>
                <td style={{ padding: '12px', fontSize: 14 }}>{tx.orderId}</td>
                <td style={{ padding: '12px', fontSize: 14 }}>{tx.customer}</td>
                <td style={{ padding: '12px', fontSize: 14 }}>{tx.items}</td>
                <td style={{ padding: '12px', fontSize: 14, textAlign: 'right' }}>
                  {formatMoney(tx.grossAmount)}
                </td>
                <td style={{ padding: '12px', fontSize: 14, textAlign: 'right' }}>
                  -{formatMoney(tx.fee)}
                </td>
                <td style={{ padding: '12px', fontSize: 14, textAlign: 'right' }}>
                  {formatMoney(tx.netAmount)}
                </td>
                <td style={{ padding: '12px', fontSize: 14, textAlign: 'center' }}>
                  <Chip
                    label={tx.type}
                    color={tx.type === 'order' ? 'success' : 'error'}
                    size="small"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
